import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function ArrowWithLineIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M16.446 11.25l-2.672-2.31 1.09-.94 4.636 4-4.636 4-1.09-.94 2.672-2.31H4.5v-1.5h11.946z" />
    </IconWrapper>
  );
}
